import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { Produit } from "../../core/model/produit";
import { ProduitService } from "../../core/service/produit.service";

@Component({
  selector: "app-edit-produit",
  templateUrl: "./edit-produit.component.html",
  styleUrls: ["./edit-produit.component.scss"],
})
export class EditProduitComponent implements OnInit {
  pressButton: Boolean = false;
  form: FormGroup;
  loading = true;

  produitId: number;
  produit: Produit;

  constructor(
    private _router: Router,
    private _produitService: ProduitService,
    private _activatedRoute: ActivatedRoute,
    private fb: FormBuilder
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      code: [null, Validators.compose([Validators.required])],
      label: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.produitId = params["produitId"];
      this.getProduit(this.produitId);
    });
  }

  getProduit(produitId) {
    this.loading = true;
    this._produitService.getProduitById(produitId).subscribe(
      (data) => {
        this.produit = { ...data };
        this.loading = false;
      },
      (error) => {
        console.log(error);
        this.loading = false;
      }
    );
  }

  save(): void {
    this.pressButton = true;
    this._produitService
      .update(this.produit)
      .pipe(first())
      .subscribe(
        (data) => {
          this.pressButton = false;
          this.goToList();
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }

  cancel(): void {
    this.goToList();
  }

  private goToList(): void {
    this._router.navigateByUrl(
      "/parametrage/produit/" + this.produit.typeCredit.id
    );
  }
}
